var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_2761)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_513_2761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7012 90.9844C85.2757 90.9844 91.416 84.844 91.416 77.2695C91.416 69.695 85.2757 63.5547 77.7012 63.5547C70.1267 63.5547 63.9863 69.695 63.9863 77.2695C63.9863 84.844 70.1267 90.9844 77.7012 90.9844Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6993 49.3984C96.1133 49.3984 113.219 52.0407 126.117 56.481C141.658 61.8311 151.212 69.9405 151.212 77.2836C151.212 84.9356 141.086 93.5508 124.398 99.08C111.781 103.26 95.1789 105.442 77.6993 105.442C59.7779 105.442 42.8073 103.394 30.0484 99.034C13.9062 93.5166 4.18359 84.7899 4.18359 77.2836C4.18359 70.0001 13.3064 61.9533 28.6282 56.6114C41.5743 52.0978 59.1029 49.3984 77.6968 49.3984H77.6993Z",
    stroke: "#00D8FF",
    strokeWidth: 6.56121
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.425 63.4067C62.6243 47.4553 73.4585 33.9567 83.7487 25.0017C96.1467 14.2124 107.945 9.98693 114.306 13.6549C120.935 17.4776 123.339 30.5539 119.792 47.7721C117.113 60.7901 110.706 76.262 101.974 91.4042C93.0205 106.929 82.7686 120.607 72.6187 129.479C59.7751 140.706 47.358 144.769 40.8556 141.019C34.5459 137.383 32.133 125.458 35.1599 109.516C37.7174 96.0468 44.1357 79.5139 53.422 63.4064L53.425 63.4067Z",
    stroke: "#00D8FF",
    strokeWidth: 6.56121
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4486 91.4445C44.2232 75.5112 37.9422 59.3802 35.3205 45.9931C32.1645 29.8634 34.3959 17.5311 40.751 13.8524C47.3734 10.0185 59.9029 14.4659 73.0486 26.1383C82.9877 34.9631 93.1937 48.2379 101.952 63.3658C110.931 78.8757 117.66 94.589 120.278 107.813C123.591 124.548 120.91 137.334 114.413 141.095C108.11 144.744 96.5749 140.881 84.2754 130.296C73.8832 121.354 62.765 107.536 53.4486 91.4443V91.4445Z",
    stroke: "#00D8FF",
    strokeWidth: 6.56121
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_2761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.586,
    height: 153.586,
    fill: "white",
    transform: "translate(0.908203 0.601562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_513_2761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.586,
    height: 153.586,
    fill: "white",
    transform: "translate(0.908203 0.601562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.2dbf3c70cfbb4680b0451ce6619ed966.svg";
export { ForwardRef as ReactComponent };